module.exports = __webpack_public_path__ + "static/media/communication.63856ccb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/communication.svg
// module id = 2459
// module chunks = 0